import { PromotionCampaignStatusEnum } from "./status-enum";

export const promotionCampaignStatusLabels = Object.freeze({
  [PromotionCampaignStatusEnum.DRAFT]: "Draft",
  [PromotionCampaignStatusEnum.ACTIVE]: "Aktif",
  [PromotionCampaignStatusEnum.PAUSED]: "Dijeda",
  [PromotionCampaignStatusEnum.DEPLETED]: "Habis",
  [PromotionCampaignStatusEnum.EXPIRED]: "Kedaluwarsa",
});
